import { ButtonHTMLAttributes } from "react";
import styled from "styled-components";

interface PrerequisiteItemProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly title: string;
  readonly numberOfItems?: number;
}
export function PrerequisiteItem({
  title,
  numberOfItems,
  ...buttonProps
}: PrerequisiteItemProps): React.JSX.Element {
  return (
    <PrerequisiteItemContainer aria-label={title} {...buttonProps}>
      <div />
      <PrerequisiteItemContentContainer>
        <span>{title}</span>
        {numberOfItems && <span style={{ fontWeight: "normal" }}>{numberOfItems}</span>}
        <tractie-icon name="chevron-right" />
      </PrerequisiteItemContentContainer>
    </PrerequisiteItemContainer>
  );
}

const PrerequisiteItemContainer = styled.button`
  all: unset;
  display: grid;
  grid-template-columns: 4px 1fr;

  & > *:first-child {
    background-color: ${(props) => props.theme.colors.borderInfo};
    border-bottom: 1px solid ${(props) => props.theme.colors.borderSubtle};
    width: 4px;
    height: 100%;
  }

  &:hover > *:first-child {
    background-color: ${(props) => props.theme.colors.borderInfo};
  }

  &:hover {
    background-color: ${(props) => props.theme.colors.backgroundSunken};
    svg {
      color: ${(props) => props.theme.colors.contentInteractiveHover};
    }
  }

  &:focus {
    background-color: ${(props) => props.theme.colors.backgroundSunken};
    svg {
      color: ${({ theme }) => theme.colors.contentInteractiveHover};
    }
  }

  &:active {
    background-color: ${(props) => props.theme.colors.backgroundPressed};
    svg {
      color: ${(props) => props.theme.colors.contentInteractivePressed};
    }
  }
`;

const PrerequisiteItemContentContainer = styled.div`
  color: ${(props) => props.theme.colors.contentSubtle};
  ${(props) => props.theme.typography.text.regular.sm};
  display: grid;
  grid-template-columns: 180px 1fr 24px;
  padding: 4px 0px 6px 0px;
  justify-content: left;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.colors.borderSubtle};

  span {
    color: ${(props) => props.theme.colors.contentEmphasis};
    margin-left: ${(props) => props.theme.spacing.spacing2.toString()};
    font-size: ${(props) => props.theme.typography.sizeSM.toString()};
    font-style: normal;
    font-weight: ${(props) => props.theme.typography.weightBold};
    line-height: 150%; /* 21px */
  }

  svg {
    color: ${(props) => props.theme.colors.contentInteractive};
  }
`;
